const GRANTS = {
    manager: [
        "admin:access",
        "content:write",
        "listings:write",
        "listings:archive",
        "listings:read_cost",
        "business:read",
        "business:write",
        "employees:manage",
        "investors:manage",
        "appointments:staff",
        "backup:export",
        "orders:manage",
        "orders:view",
    ],
    /** Read-only order history; no refund (orders:manage). */
    order_viewer: ["orders:view"],
    editor: ["content:write"],
    sales: ["listings:write", "listings:archive", "appointments:staff"],
    finance: ["business:read", "business:write", "investors:manage", "listings:read_cost"],
    technician: ["appointments:staff"],
};
/** Legacy Al-Amir "admin" maps to Lumora manager. */
export function normalizeDealershipRole(role) {
    if (role === "admin")
        return "manager";
    return role;
}
export function roleHasDealershipCapability(role, capability) {
    if (role === "owner")
        return true;
    const key = normalizeDealershipRole(String(role));
    return GRANTS[key]?.includes(capability) ?? false;
}
//# sourceMappingURL=dealershipCapabilities.js.map